import "util/print_debug";
import "vendors/segment";
import "vendors/google_maps";
import "vendors/branch";
import { waitForAndRender } from "polyfills";

waitForAndRender(() => import("title_portal/router"));
